module.exports = __webpack_public_path__ + "img/locked-profile.896dea80.svg";